import { useNavigate, Link } from "react-router-dom";
import projectData from "../data/projects.json";

function Projects({ spotlightOnly = false }) {
  const navigate = useNavigate();
  const displayProjects = spotlightOnly
    ? projectData.filter(project => project.spotlight)
    : projectData;

  return (
    <main className="projects" role="main" aria-label="Projects list">
      <div className="item-grid" id="project-grid">
        {displayProjects.map(project => (
          <article
            className="grid-item"
            key={project.slug}
            aria-labelledby={`project-title-${project.slug}`}
          >
            <div
              className="item-card"
              id={`catalog-${project.name}`}
            >
              <Link
                to={`/project/${project.slug}`}
                aria-label={`View project: ${project.name}`}
              >
                <img
                  src={project.preview}
                  alt={`${project.name} project preview`}
                />
              </Link>
            </div>

            <div className="tags" aria-label="Project tags">
              {project.tags.map((tag, j) => (
                <span key={j} className="tag">
                  {tag}
                </span>
              ))}
            </div>

            <p
              className="project-description"
              id={`project-title-${project.slug}`}
            >
              {project.description}
            </p>

            
          </article>
        ))}

        
      </div>
       <button
        type="button"
        className="more-projects"
        onClick={() => navigate("/design-gallery")}
        aria-label="View more projects"
      >
        View my designs
      </button>
    </main>
  );
}

export default Projects;